export const createTransferEn = {};

export const createTransferFr = {};
